export enum DataType {
  String = 'string',
  Integer = 'int',
  Float = 'float',
  Boolean = 'bool',
  Object = 'object',
}
